<template>
  <div>
    <vue-dropzone
      ref="myVueDropzone"
      id="dropzone"
      :options="dropzoneOptions"
      @vdropzone-success="printResponse(...arguments)"
    ></vue-dropzone>
  </div>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { eventBus } from "@/main";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
// https://rowanwins.github.io/vue-dropzone/docs/dist/index.html#/installation
import { convertFilename } from '@/utils';

@Component({
  components: {
    vueDropzone: vue2Dropzone
  }
})
export default class FileUpload extends Vue {
  dropzoneOptions = {
    url: "/api/file-upload",
    renameFile: (file) => convertFilename(file.name), // function to be applied before uploading, param is of type File.
    paramName: "file",
    dictDefaultMessage: this.$store.state.user.langEng
      ? "Click or drop files here"
      : "Klicka eller släpp filer här",
    autoProcessQueue: true,
    addRemoveLinks: true,
    duplicateCheck: true,
    thumbnailHeight: 150,
    thumbnailWidth: 150,
    maxFilesize: 50
  };

  printResponse(file, res) {
    if (file.type === 'application/x-zip-compressed') {
      this.$store.commit('appendZipFile', res.id);
    } else if (file.type.includes("image")) {
      setTimeout(() => {
        eventBus.$emit("addImageToMarkdown", res.id);
      }, 100);
    } else {
      eventBus.$emit("addFileToContentArea", res);
    }

    const done = this.$refs.myVueDropzone.getQueuedFiles().length + this.$refs.myVueDropzone.getUploadingFiles().length == 0;
    if (done && !this.$store.state.article.zipFiles.length) {
      this.$store.commit('setCurrentContentArea', 'TextArea');
    }
  }
}
</script>

<style>
.dropzone .dz-preview .dz-image {
  z-index: 3;
}
</style>
